import BenchlingConfig from 'BenchlingConfig';
import ProcedureHeaderActionButtons from 'procedures/design/ProcedureHeaderActionButtons';
import ProcedureTemplateCollectibleBadge from 'procedures/design/ProcedureTemplateCollectibleBadge';
import {
  ProcedureValidationError,
  ProcedureValidationObjectType,
  ProcedureValidationErrorType,
} from 'procedures/design/validation/ProcedureValidationTypes';
import ProcedureMethodNodeAdapter from 'procedures/processes/ProcedureMethodNodeAdapter';
import {ProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {FlowchartValidator} from 'processes/graph-builder-processes/platform/FlowchartValidator';
import {
  ProcessesPluginBase,
  ProcessesPluginMetadataEditorItem,
} from 'processes/graph-builder-processes/platform/ProcessesPluginBase';
import {ProcessFlowchartConfigEditorHeaderConfig} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/ProcessFlowchartConfigEditorHeaderTypes';

import ProcedureFlowchartValidator from './ProcedureFlowchartValidator';
import ProcedureRootNodeAdapter from './ProcedureRootNodeAdapter';

export class ProcedureProcessesPlugin extends ProcessesPluginBase {
  static readonly FLOWCHART_TYPE_NAME = 'PROCEDURE_FLOWCHART';

  static override readonly pluginName = 'Procedures Plugin';
  readonly flowchartTypeName: string = ProcedureProcessesPlugin.FLOWCHART_TYPE_NAME;

  readonly nodeAdapters: Array<ProcessFlowchartNodeAdapter> = [
    new ProcedureMethodNodeAdapter(),
    new ProcedureRootNodeAdapter(),
  ];

  readonly flowchartValidator: FlowchartValidator<
    ProcedureValidationError,
    ProcedureValidationErrorType,
    ProcedureValidationObjectType
  > = new ProcedureFlowchartValidator();
  readonly metadataEditor?: ProcessesPluginMetadataEditorItem = undefined;

  override readonly headerConfig: ProcessFlowchartConfigEditorHeaderConfig = {
    // We use dynamicIcon in the headerConfigMetadata since the icon is based on the procedure type, so this
    // will be overriden.
    icon: 'list',
    // We use dynamicBreadcrumbs in the headerConfigMetadata since the breadcrumb is dynamic, based on
    // the procedure's template collection
    breadcrumbItems: [],
    headerLeftContent: BenchlingConfig.ENABLE_TEMPLATE_COLLECTIONS_IN_WORKSPACE
      ? ProcedureTemplateCollectibleBadge
      : undefined,
    actionsComponent: ProcedureHeaderActionButtons,
  };
}
